import africaSafariEnDarkLogo from 'assets/images/logos/africa-safari-en.png';
import africaSafariFrDarkLogo from 'assets/images/logos/africa-safari-fr.png';
import africaSafariDeDarkLogo from 'assets/images/logos/africa-safari-de.png';
import africaSafariEsDarkLogo from 'assets/images/logos/africa-safari-es.png';
import africaSafariNlDarkLogo from 'assets/images/logos/africa-safari-nl.png';
import africaSafariDkDarkLogo from 'assets/images/logos/africa-safari-dk.png';
import africaSafariSeDarkLogo from 'assets/images/logos/africa-safari-se.png';
import africaSafariNoDarkLogo from 'assets/images/logos/africa-safari-no.png';
import africaSafariEnLightLogo from 'assets/images/logos/new-africa-safari-light-logo-en.png';
import africaSafariFrLightLogo from 'assets/images/logos/new-africa-safari-light-logo-fr.png';
import africaSafariDeLightLogo from 'assets/images/logos/new-africa-safari-light-logo-de.png';
import africaSafariNlLightLogo from 'assets/images/logos/new-africa-safari-light-logo-nl.png';
import africaSafariDkLightLogo from 'assets/images/logos/new-africa-safari-light-logo-dk.png';
import africaSafariSeLightLogo from 'assets/images/logos/new-africa-safari-light-logo-se.png';
import africaSafariNoLightLogo from 'assets/images/logos/new-africa-safari-light-logo-no.png';
import africaSafariEsLightLogo from 'assets/images/logos/new-africa-safari-light-logo-es.png';
import tanzaniaSpecialistEnLightLogo from 'assets/images/logos/new-tanzania-specialist-light-logo-en.png';
import tanzaniaSpecialistFrLightLogo from 'assets/images/logos/new-tanzania-specialist-light-logo-fr.png';
import tanzaniaSpecialistDeLightLogo from 'assets/images/logos/new-tanzania-specialist-light-logo-de.png';
import tanzaniaSpecialistEsLightLogo from 'assets/images/logos/new-tanzania-specialist-light-logo-es.png';
import tanzaniaSpecialistNlLightLogo from 'assets/images/logos/new-tanzania-specialist-light-logo-nl.png';
import tanzaniaSpecialistDkLightLogo from 'assets/images/logos/new-tanzania-specialist-light-logo-dk.png';
import tanzaniaSpecialistSeLightLogo from 'assets/images/logos/new-tanzania-specialist-light-logo-se.png';
import tanzaniaSpecialistNoLightLogo from 'assets/images/logos/new-tanzania-specialist-light-logo-no.png';
import tanzaniaSpecialistEnDarkLogo from 'assets/images/logos/tanzania-specialist-en.png';
import tanzaniaSpecialistFrDarkLogo from 'assets/images/logos/tanzania-specialist-fr.png';
import tanzaniaSpecialistDeDarkLogo from 'assets/images/logos/tanzania-specialist-de.png';
import tanzaniaSpecialistEsDarkLogo from 'assets/images/logos/tanzania-specialist-es.png';
import tanzaniaSpecialistNlDarkLogo from 'assets/images/logos/tanzania-specialist-en.png';
import tanzaniaSpecialistDkDarkLogo from 'assets/images/logos/tanzania-specialist-dk.png';
import tanzaniaSpecialistSeDarkLogo from 'assets/images/logos/tanzania-specialist-se.png';
import tanzaniaSpecialistNoDarkLogo from 'assets/images/logos/tanzania-specialist-no.png';
import germanyFlag from 'assets/images/flags/germany_flag.png';
import unitedKingdomFlag from 'assets/images/flags/united_kingdom_flag.png';
import spainFlag from 'assets/images/flags/spain_flag.png';
import franceFlag from 'assets/images/flags/france_flag.png';
import netherlandsFlag from 'assets/images/flags/netherlands_flag.png';
import denmarkFlag from 'assets/images/flags/denmark_flag.png';
import swedenFlag from 'assets/images/flags/sweden_flag.png';
import norwayFlag from 'assets/images/flags/norway_flag.png';

export enum LanguageEnum {
  EN = 'en',
  DE = 'de',
  ES = 'es',
  FR = 'fr',
  NL = 'nl',
  NO = 'no',
  DA = 'da',
  SV = 'sv',
}

export enum LanguageFullNameEnum {
  da = 'Dansk',
  de = 'Deutsch',
  en = 'English',
  es = 'Español',
  fr = 'Français',
  nl = 'Nederlands',
  no = 'Norsk',
  sv = 'Svenska',
}

export const AFRICA_SAFARI_DARK_LOGOS: Record<LanguageEnum, string> = {
  [LanguageEnum.EN]: africaSafariEnDarkLogo,
  [LanguageEnum.FR]: africaSafariFrDarkLogo,
  [LanguageEnum.DE]: africaSafariDeDarkLogo,
  [LanguageEnum.ES]: africaSafariEsDarkLogo,
  [LanguageEnum.NL]: africaSafariNlDarkLogo,
  [LanguageEnum.DA]: africaSafariDkDarkLogo,
  [LanguageEnum.SV]: africaSafariSeDarkLogo,
  [LanguageEnum.NO]: africaSafariNoDarkLogo,
};

export const AFRICA_SAFARI_LIGHT_LOGOS: Record<LanguageEnum, string> = {
  [LanguageEnum.EN]: africaSafariEnLightLogo,
  [LanguageEnum.FR]: africaSafariFrLightLogo,
  [LanguageEnum.DE]: africaSafariDeLightLogo,
  [LanguageEnum.ES]: africaSafariEsLightLogo,
  [LanguageEnum.NL]: africaSafariNlLightLogo,
  [LanguageEnum.DA]: africaSafariDkLightLogo,
  [LanguageEnum.SV]: africaSafariSeLightLogo,
  [LanguageEnum.NO]: africaSafariNoLightLogo,
};

export const TANZANIA_SPECIALIST_DARK_LOGOS: Record<LanguageEnum, string> = {
  [LanguageEnum.EN]: tanzaniaSpecialistEnDarkLogo,
  [LanguageEnum.FR]: tanzaniaSpecialistFrDarkLogo,
  [LanguageEnum.DE]: tanzaniaSpecialistDeDarkLogo,
  [LanguageEnum.ES]: tanzaniaSpecialistEsDarkLogo,
  [LanguageEnum.NL]: tanzaniaSpecialistNlDarkLogo,
  [LanguageEnum.DA]: tanzaniaSpecialistDkDarkLogo,
  [LanguageEnum.SV]: tanzaniaSpecialistSeDarkLogo,
  [LanguageEnum.NO]: tanzaniaSpecialistNoDarkLogo,
};

export const TANZANIA_SPECIALIST_LIGHT_LOGOS: Record<LanguageEnum, string> = {
  [LanguageEnum.EN]: tanzaniaSpecialistEnLightLogo,
  [LanguageEnum.FR]: tanzaniaSpecialistFrLightLogo,
  [LanguageEnum.DE]: tanzaniaSpecialistDeLightLogo,
  [LanguageEnum.ES]: tanzaniaSpecialistEsLightLogo,
  [LanguageEnum.NL]: tanzaniaSpecialistNlLightLogo,
  [LanguageEnum.DA]: tanzaniaSpecialistDkLightLogo,
  [LanguageEnum.SV]: tanzaniaSpecialistSeLightLogo,
  [LanguageEnum.NO]: tanzaniaSpecialistNoLightLogo,
};

export const LANGUAGES_FLAGS: Record<LanguageEnum, string> = {
  [LanguageEnum.DE]: germanyFlag,
  [LanguageEnum.EN]: unitedKingdomFlag,
  [LanguageEnum.ES]: spainFlag,
  [LanguageEnum.FR]: franceFlag,
  [LanguageEnum.NL]: netherlandsFlag,
  [LanguageEnum.DA]: denmarkFlag,
  [LanguageEnum.SV]: swedenFlag,
  [LanguageEnum.NO]: norwayFlag,
};

export enum FlightTicketProposalStatusEnum {
  NEW = 'New',
  PENDING = 'Pending',
  EXPIRED = 'Expired',
  DECLINED = 'Declined',
  NOT_PAID = 'Not paid',
  CONFIRMED_AND_PAID = 'Confirmed and paid',
  TICKETS_SENT = 'Tickets sent',
  OPERATED = 'Operated',
}

export const FLIGHT_TICKET_PROPOSAL_STATUS_TRANSLATION_KEY_MAP: Record<FlightTicketProposalStatusEnum, string> = {
  [FlightTicketProposalStatusEnum.NEW]: 'flights.statuses.new',
  [FlightTicketProposalStatusEnum.PENDING]: 'flights.statuses.pending',
  [FlightTicketProposalStatusEnum.EXPIRED]: 'flights.statuses.expired',
  [FlightTicketProposalStatusEnum.DECLINED]: 'flights.statuses.declined',
  [FlightTicketProposalStatusEnum.NOT_PAID]: 'flights.statuses.awaiting_payment',
  [FlightTicketProposalStatusEnum.CONFIRMED_AND_PAID]: 'flights.statuses.confirmed',
  [FlightTicketProposalStatusEnum.TICKETS_SENT]: 'flights.statuses.tickets_received',
  [FlightTicketProposalStatusEnum.OPERATED]: 'flights.statuses.completed',
};

export const TANZANIA_SPECIALIST_TRIP_ADVISOR: Record<LanguageEnum, string> = {
  [LanguageEnum.EN]: 'https://www.tripadvisor.com/Attraction_Review-g297913-d12997236-Reviews-Tanzania_Specialist',
  [LanguageEnum.DE]: 'https://www.tripadvisor.de/Attraction_Review-g297913-d12997236-Reviews-Tanzania_Specialist',
  [LanguageEnum.ES]: 'https://www.tripadvisor.es/Attraction_Review-g297913-d12997236-Reviews-Tanzania_Specialist',
  [LanguageEnum.FR]: 'https://www.tripadvisor.fr/Attraction_Review-g297913-d12997236-Reviews-Tanzania_Specialist',
  [LanguageEnum.NL]: 'https://www.tripadvisor.nl/Attraction_Review-g297913-d12997236-Reviews-Tanzania_Specialist',
  [LanguageEnum.DA]: 'https://www.tripadvisor.dk/Attraction_Review-g297913-d12997236-Reviews-Tanzania_Specialist',
  [LanguageEnum.SV]: 'https://www.tripadvisor.se/Attraction_Review-g297913-d12997236-Reviews-Tanzania_Specialist',
  [LanguageEnum.NO]: 'https://no.tripadvisor.com/Attraction_Review-g297913-d12997236-Reviews-Tanzania_Specialist',
};

export const TANZANIA_SPECIALIST_INSTAGRAM: Record<LanguageEnum, string> = {
  [LanguageEnum.EN]: 'https://www.instagram.com/tanzaniaspecialist/',
  [LanguageEnum.DE]: 'https://www.instagram.com/tanzaniaspecialist.de/',
  [LanguageEnum.ES]: 'https://www.instagram.com/tanzaniaspecialist.es/',
  [LanguageEnum.FR]: 'https://www.instagram.com/tanzaniaspecialist.fr/',
  [LanguageEnum.NL]: 'https://www.instagram.com/tanzaniaspecialist/',
  [LanguageEnum.DA]: 'https://www.instagram.com/tanzaniaspecialist/',
  [LanguageEnum.SV]: 'https://www.instagram.com/tanzaniaspecialist/',
  [LanguageEnum.NO]: 'https://www.instagram.com/tanzaniaspecialist/',
};

export const TANZANIA_SPECIALIST_FACEBOOK: Record<LanguageEnum, string> = {
  [LanguageEnum.EN]: 'https://www.facebook.com/tanzaniaspecialist',
  [LanguageEnum.DE]: 'https://www.facebook.com/people/TanzaniaSpecialistde/61552736244110/',
  [LanguageEnum.ES]: 'https://www.facebook.com/people/TanzaniaSpecialistes/61552810100117/',
  [LanguageEnum.FR]: 'https://www.facebook.com/people/TanzaniaSpecialistfr/61552754601926/',
  [LanguageEnum.NL]: 'https://www.facebook.com/tanzaniaspecialist',
  [LanguageEnum.DA]: 'https://www.facebook.com/tanzaniaspecialist',
  [LanguageEnum.SV]: 'https://www.facebook.com/tanzaniaspecialist',
  [LanguageEnum.NO]: 'https://www.facebook.com/tanzaniaspecialist',
};

export const TANZANIA_SPECIALIST_TERMS_AND_CONDITIONS: Record<LanguageEnum, string> = {
  [LanguageEnum.EN]: 'https://tanzania-specialist.com/terms-conditions/',
  [LanguageEnum.DE]: 'https://tanzaniaspecialist.de/allgemeine-geschaeftsbedingungen/',
  [LanguageEnum.ES]: 'https://tanzaniaspecialist.es/terminos-y-condiciones/',
  [LanguageEnum.FR]: 'https://tanzaniaspecialist.fr/conditions-generales/',
  [LanguageEnum.NL]: 'https://tanzaniaspecialist.com/algemene-voorwaarden/',
  [LanguageEnum.DA]: 'https://tanzaniaspecialist.dk/vilkaar-og-betingelser/',
  [LanguageEnum.SV]: 'https://tanzania-specialist.se/villkor/',
  [LanguageEnum.NO]: 'https://tanzaniaspecialist.no/vilkaar-betingelser/',
};

export const TANZANIA_SPECIALIST_PRIVATE_POLICY: Record<LanguageEnum, string> = {
  [LanguageEnum.EN]: 'https://tanzania-specialist.com/privacy-policy/',
  [LanguageEnum.DE]: 'https://tanzaniaspecialist.de/datenschutzerklaerung/',
  [LanguageEnum.ES]: 'https://tanzaniaspecialist.es/politica-de-privacidad/',
  [LanguageEnum.FR]: 'https://tanzaniaspecialist.fr/politique-de-confidentialite/',
  [LanguageEnum.NL]: 'https://tanzaniaspecialist.com/privacybeleid/',
  [LanguageEnum.DA]: 'https://tanzaniaspecialist.dk/privatlivspolitik/',
  [LanguageEnum.SV]: 'https://tanzania-specialist.se/integritetspolicy/',
  [LanguageEnum.NO]: 'https://tanzaniaspecialist.no/personvern/',
};

export const AFRICA_SAFARI_TRIP_ADVISOR: Record<LanguageEnum, string> = {
  [LanguageEnum.EN]: 'https://www.tripadvisor.com/Attraction_Review-g294207-d23785153/',
  [LanguageEnum.DE]: 'https://www.tripadvisor.de/Attraction_Review-g294207-d23785153/',
  [LanguageEnum.ES]: 'https://www.tripadvisor.es/Attraction_Review-g294207-d23785153/',
  [LanguageEnum.FR]: 'https://www.tripadvisor.fr/Attraction_Review-g294207-d23785153/',
  [LanguageEnum.NL]: 'https://www.tripadvisor.nl/Attraction_Review-g294207-d23785153/',
  [LanguageEnum.DA]: 'https://www.tripadvisor.dk/Attraction_Review-g294207-d23785153/',
  [LanguageEnum.SV]: 'https://www.tripadvisor.se/Attraction_Review-g294207-d23785153/',
  [LanguageEnum.NO]: 'https://no.tripadvisor.com/Attraction_Review-g294207-d23785153/',
};

export const AFRICA_SAFARI_INSTAGRAM: Record<LanguageEnum, string> = {
  [LanguageEnum.EN]: 'https://www.instagram.com/africasafaritrips/',
  [LanguageEnum.DE]: 'https://www.instagram.com/afrikasafariurlaub/',
  [LanguageEnum.ES]: 'https://www.instagram.com/safari_africano/',
  [LanguageEnum.FR]: 'https://www.instagram.com/safari_en_afrique/',
  [LanguageEnum.NL]: 'https://www.instagram.com/africasafaritrips/',
  [LanguageEnum.DA]: 'https://www.instagram.com/africasafaritrips/',
  [LanguageEnum.SV]: 'https://www.instagram.com/africasafaritrips/',
  [LanguageEnum.NO]: 'https://www.instagram.com/africasafaritrips/',
};

export const AFRICA_SAFARI_FACEBOOK: Record<LanguageEnum, string> = {
  [LanguageEnum.EN]: 'https://www.facebook.com/africasafaritrips',
  [LanguageEnum.DE]: 'https://www.facebook.com/afrikasafariurlaub',
  [LanguageEnum.ES]: 'https://www.facebook.com/safariafricano.es',
  [LanguageEnum.FR]: 'https://www.facebook.com/safarienafriquefr/',
  [LanguageEnum.NL]: 'https://www.facebook.com/africasafaritrips',
  [LanguageEnum.DA]: 'https://www.facebook.com/africasafaritrips',
  [LanguageEnum.SV]: 'https://www.facebook.com/africasafaritrips',
  [LanguageEnum.NO]: 'https://www.facebook.com/africasafaritrips',
};

export const AFRICA_SAFARI_TERMS_AND_CONDITIONS: Record<LanguageEnum, string> = {
  [LanguageEnum.EN]: 'https://africasafaritrips.com/terms-conditions/',
  [LanguageEnum.DE]: 'https://afrikasafariurlaub.de/allgemeine-geschaeftsbedingungen/',
  [LanguageEnum.ES]: 'https://safariafricano.es/terminos-y-condiciones/',
  [LanguageEnum.FR]: 'https://safarienafrique.fr/conditions-generales/',
  [LanguageEnum.NL]: 'https://afrikasafari.nl/algemene-voorwaarden/',
  [LanguageEnum.DA]: 'https://afrikasafarirejser.dk/vilkaar-og-betingelser/',
  [LanguageEnum.SV]: 'https://afrikasafariresor.se/villkor/',
  [LanguageEnum.NO]: 'https://safarireiserafrika.no/vilkar-og-betingelser/',
};

export const AFRICA_SAFARI_PRIVATE_POLICY: Record<LanguageEnum, string> = {
  [LanguageEnum.EN]: 'https://africasafaritrips.com/privacy-policy/',
  [LanguageEnum.DE]: 'https://afrikasafariurlaub.de/datenschutzerklaerung/',
  [LanguageEnum.ES]: 'https://safariafricano.es/politica-de-privacidad/',
  [LanguageEnum.FR]: 'https://safarienafrique.fr/politique-de-confidentialite/',
  [LanguageEnum.NL]: 'https://afrikasafari.nl/privacybeleid/',
  [LanguageEnum.DA]: 'https://afrikasafarirejser.dk/privatlivspolitik/',
  [LanguageEnum.SV]: 'https://afrikasafariresor.se/integritetspolicy/',
  [LanguageEnum.NO]: 'https://safarireiserafrika.no/retningslinjer-for-personvern/',
};

export enum LocalStorageKeyEnum {
  LANGUAGE_PREFERENCE = 'language_preference',
  AUTH_TOKEN = 'auth_token',
}

export const REDIRECT_PARAMETER_KEY = 'redirectTo';
